module.exports = {
    blog_title:'Blog de Taption',
    blog_desc:'Artículos útiles y consejos para creadores. Actualizaciones de productos, noticias e información de Taption.',
    written_by: 'Escrito por', 
}
